module.exports = __webpack_public_path__ + "static/img/ChrisCavanagh.18109e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ChrisCavanagh.jpg
// module id = MIeQ
// module chunks = 0